// import VideoCallScreen from "@components/VideoCall/VideoCallScreen";

// export default VideoCallScreen;

export default function VideoCallScreen() {
  return null;
}
